import axios from 'CanExConfig/axios'

export const searchCandidateRoles = async term => {
  const response = await axios('/search/roles', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}
